/*
 * RS language selector (snippets/rs-language-selector.liquid). The form works without this script
 * (each language is a submit button); this only closes the dropdown on a click outside, on Escape
 * and when focus leaves it, and keeps one dropdown open at a time. On mobile the header's
 * "sheet" also closes on its dark overlay and its X.
 */
if (!customElements.get('rs-language-selector')) {
  customElements.define(
    'rs-language-selector',
    class RsLanguageSelector extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        if (!this.details) return;
        this.onDocClick = (event) => {
          if (this.details.open && !this.contains(event.target)) this.close();
        };
        this.onKey = (event) => {
          if (event.key === 'Escape' && this.details.open) {
            event.stopPropagation();
            this.close(true);
          }
        };
        this.details.addEventListener('toggle', () => {
          if (!this.details.open) return;
          document.querySelectorAll('rs-language-selector details[open]').forEach((other) => {
            if (other !== this.details) other.open = false;
          });
        });
        // Mobile sheet: a tap on the dark overlay (the open details itself) or on the X closes it
        this.addEventListener('click', (event) => {
          if (event.target === this.details || event.target.closest('[data-rs-lang-close]')) {
            event.preventDefault();
            this.close(true);
          }
        });
        this.addEventListener('keydown', this.onKey);
        this.addEventListener('focusout', (event) => {
          if (this.details.open && event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
        });
        document.addEventListener('click', this.onDocClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
      }

      close(focusSummary) {
        this.details.open = false;
        if (focusSummary) this.details.querySelector('summary')?.focus();
      }
    }
  );
}
